"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animation = void 0;
var animation = exports.animation = function animation(_ref) {
  var prevTab = _ref.prevTab,
    currentTab = _ref.currentTab,
    animatedSlider = _ref.animatedSlider,
    tabContainer = _ref.tabContainer;
  if (prevTab && 'animate' in prevTab) {
    var parent = tabContainer.getBoundingClientRect();
    var originChild = prevTab.getBoundingClientRect();
    var destinationChild = currentTab.getBoundingClientRect();
    var initial = originChild.left - parent.left;
    var _final = destinationChild.left - parent.left;
    var initialTabWidth = "".concat(prevTab.getBoundingClientRect().width, "px");
    var finalTabWidth = "".concat(currentTab.getBoundingClientRect().width, "px");
    var anim = animatedSlider.animate([{
      width: initialTabWidth,
      transform: "translate(".concat(initial, "px, 0px)")
    }, {
      width: finalTabWidth,
      transform: "translate(".concat(_final, "px, 0px)")
    }], {
      duration: 300,
      fill: 'both',
      easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
    });
    return new Promise(function (resolve) {
      anim.onfinish = resolve;
    });
  }
  return Promise.resolve();
};